var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:("img-thumbnail list-thumbnail align-self-center " + _vm.className + "\n  " + (_vm.rounded!=undefined && 'rounded-circle') + " " + (_vm.small!=undefined && 'small')),attrs:{"alt":_vm.alt,"src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }